import { Fragment, type MouseEventHandler, useMemo } from 'react';
import { parseBroadcastBodyToSegments } from '../utils/broadcastLinkMarkup';

interface BroadcastMessageBodyProps {
  text: string;
  className?: string;
  linkClassName?: string;
  onLinkClick?: MouseEventHandler<HTMLAnchorElement>;
}

export default function BroadcastMessageBody({
  text,
  className,
  linkClassName,
  onLinkClick,
}: BroadcastMessageBodyProps) {
  const segments = useMemo(() => parseBroadcastBodyToSegments(text), [text]);
  return (
    <span className={className}>
      {segments.map((seg, i) =>
        seg.type === 'text' ? (
          <Fragment key={i}>{seg.text}</Fragment>
        ) : (
          <a
            key={i}
            href={seg.href}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClassName}
            onClick={onLinkClick}
          >
            {seg.label}
          </a>
        ),
      )}
    </span>
  );
}
